{
  "title": "LLM-Konfiguration",
  "subtitle": "Provider, API-Keys und Standard-Modell",
  "catalog": {
    "title": "Modell-Catalog",
    "model_col": "Modell",
    "context_col": "Context",
    "tools_col": "Tools",
    "category_col": "Kategorie",
    "size_col": "Größe",
    "empty": "Keine Modelle in diesem Filter.",
    "free": "gratis",
    "set_for_agent": "Modell auf Agent setzen"
  },
  "ollama": {
    "connection": "Ollama-Verbindung",
    "connected": "Verbunden",
    "offline": "Nicht erreichbar",
    "installed_models": "Installierte Modelle",
    "installed": "installiert",
    "installed_count": "{{count}} installiert",
    "search": "Offizielle Ollama Library durchsuchen…",
    "refresh": "Aktualisieren",
    "install": "Installieren",
    "remove": "Entfernen",
    "remove_confirm": "Ollama-Modell „{{model}}“ wirklich entfernen?",
    "use": "Im Agent nutzen",
    "no_models": "Keine Ollama-Modelle gefunden.",
    "no_variants": "Keine Varianten verfügbar.",
    "pull_failed": "Installation fehlgeschlagen",
    "library_offline": "Die offizielle Ollama Library ist gerade nicht erreichbar. Installierte Modelle bleiben verfügbar.",
    "fit_available": "Hardware erkannt",
    "fit_unavailable": "Hardwarebewertung nicht verfügbar",
    "llmfit_not_installed": "llmfit nicht installiert",
    "llmfit_failed": "llmfit konnte nicht ausgeführt werden",
    "llmfit_remote_ollama": "Ollama läuft auf einem anderen Host; dessen Hardware-Fit ist noch nicht verfügbar",
    "context_capped": "Genutztes Kontextfenster / theoretisches Maximum des Modells. HydraHive begrenzt den Kontext nach freiem Grafikspeicher, damit das Modell vollständig auf der GPU bleibt.",
    "fit": {
      "perfect": "perfekt",
      "good": "gut",
      "marginal": "grenzwertig",
      "too_tight": "zu groß",
      "unknown": "Fit unbekannt"
    }
  },
  "providers": {
    "title": "Provider",
    "add": "Provider hinzufügen",
    "none": "Noch kein Provider konfiguriert",
    "no_key": "Kein Key",
    "revoke_oauth": "OAuth trennen",
    "revoke_oauth_confirm": "OAuth-Verbindung für „{{provider}}\" trennen?",
    "models_count": "{{count}} Modell",
    "models_count_plural": "{{count}} Modelle"
  },
  "form": {
    "provider_label": "Provider",
    "api_key": "API Key",
    "models_label": "Modelle ({{selected}} ausgewählt)",
    "custom_model": "oder Custom-Modell eingeben…",
    "or_oauth": "oder per OAuth-Login",
    "oauth_connected": "Per OAuth verbunden"
  },
  "default_model": "Standard-Modell",
  "embed_model": "Embedding-Modell",
  "embed_model_hint": "Vektor-Dimension: {{dim}} — neue Events werden automatisch eingebettet",
  "default_models": {
    "title": "Standard-Modelle",
    "chat": "Chat",
    "embed": "Embedding",
    "image": "Bild",
    "music": "Musik",
    "tts": "Sprache (TTS)",
    "stt": "Transkription (STT)",
    "video": "Video",
    "local": "lokal",
    "free": "kostenlos",
    "paid": "kostenpflichtig",
    "cost_unknown": "Kosten unbekannt",
    "save_error": "Speichern fehlgeschlagen"
  },
  "media_models": {
    "title": "Media-Modelle",
    "hint": "Live aus dem Modell-Catalog, nach Modalität gefiltert",
    "none": "Keine passenden Modelle — OpenRouter-Key konfigurieren",
    "image": "Bild",
    "music": "Musik",
    "tts": "Sprache (TTS)",
    "transcribe": "Transkription (STT)",
    "video": "Video"
  },
  "test": {
    "button": "Verbindung testen",
    "saving": "Speichern…",
    "ok": "OK · \"{{response}}\""
  },
  "usage": {
    "loading": "Lade Rate-Limits…",
    "anthropic_title": "Anthropic OAuth Rate-Limits",
    "window_5h": "5-Stunden-Fenster",
    "window_7d": "7-Tage-Fenster",
    "resets_at": "Reset",
    "threshold_warning": "Schwellenwert überschritten",
    "threshold_explanation": "Die Nutzung hat den Schwellenwert überschritten. Anfragen könnten gedrosselt werden."
  }
}